import { ListAlt } from '@mui/icons-material'
import PhysicalExperienceSectionList from './PhysicalExperienceSectionList'
import PhysicalExperienceSectionEdit from './PhysicalExperienceSectionEdit'
import PhysicalExperienceSectionCreate from './PhysicalExperienceSectionCreate'

const physicalExperienceIndex = {
  icon: ListAlt,
  list: PhysicalExperienceSectionList,
  edit: PhysicalExperienceSectionEdit,
  create: PhysicalExperienceSectionCreate,
}

export default physicalExperienceIndex
